namespace Message {

    export const EMPLOYER = '新潟県新潟市中央区米山４丁目１番地３１号　紫竹総合ビル\n株式会社インプレッシヴ\n代表取締役　佐藤　潤一'
    export const RETIREMENT_SELF = '職務の性質により、引継ぎ期間を考慮して退職する90日以上前に届け出ること'
    export const RETIREMENT_AGE = '有（60歳）'
    export const DISMISS = '就業規則・労働基準法・その他関係法令の定めるところによる'
    export const OTHER = '本契約に定めのない事項は、就業規則・労働基準法・その他関係法令の定めるところによる'
    export const OTHER_COUNTER_PM = '・' + OTHER + '\n・雇用管理の改善等に関する事項に係る相談窓口：本社 マネージャー TEL. 000-000-1111'
    export const OTHER_COUNTER_PG = '・' + OTHER + '\n・雇用管理の改善等に関する事項に係る相談窓口：本社 マネージャー TEL. 000-000-2222'
    export const NENNJI_YUUKYUU_PART = '6ヶ月間継続勤務し、引き続き勤務する場合、労働基準法で定められた日数を付与する\n以降、1年を経過する毎に継続勤務期間応じ、定められた日数を付与する（年間最大20日）'
    export const NENNJI_YUUKYUU = '以降、継続勤務期間に応じて、労働基準法で定められた日数を付与する（年間最大20日）'
    export const KEIKAKU_YUUKYUU = '※付与した有給休暇の内、上限5日を年次有給休暇の計画付与の対象とする'
    export const WITHOUT_WORKTIME_PG = '（時間外・休日労働協定による） 但し、事前申請の上、承認を受けた業務のみ'
    export const WITHOUT_WORKTIME_PM = '所定時間外労働・休日労働をさせることが有。但し、事前申請の上、承認を受けた業務のみ'
    export const HOLIDAY = '日曜・祝日・会社指定休み\n(就業先の業務の都合によっては、事前に本人に通知の上、当社の就業規則内で振替就業することができる)'
    export const CARFARE = '※通勤手段・通勤距離に応じて当社規定により支給（上限15,000円）'
    export const UPDATE_TRUE = '契約更新する場合がある(次により判断する)\n1. 契約満了時の業務量\n2. 従事している業務の進捗状況\n3. 能力・業務成績・勤務態度\n4. 会社の経営状況'
    export const UPDATE_NONE = '契約更新しない'
    export const UPDATE_UNSELECTED = '選択されていません'
  }
  
  export default Message